<template>
  <div class="chat-preview">
    <iframe
      :src="`${widgetUrl}/?bot_id=${botId}`"
      width="400"
      height="100%"
      frameBorder="0"
      id="widger-iframe-preview"
      v-show="show"
    ></iframe>
  </div>
</template>

<script>
import common from "../../utils/common";
import env from "../../utils/env";
export default {
  name: "widgetReview",
  props: {
    widgetParameters: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      userSideRadius: "0",
      botSideRadius: "0",
      common,
      currentStep: "",
      show: false,
      direction: {
        float: "right",
        textAlign: "left",
        userFloat: "right",
        botFloat: "left",
        position: "10px",
      },
    };
  },
  mounted() {
    let wn = document.getElementById("widger-iframe-preview").contentWindow;
    wn.postMessage(this.widgetParameters, "*");
    setTimeout(() => {
      this.show = true;
    }, 3000);
    document
      .getElementById("widget-offline")
      .addEventListener("mouseover", () => {
        if (this.currentStep !== "widget-offline") {
          this.currentStep = "widget-offline";
          wn.postMessage(
            {
              type: "change-step",
              value: "widget-offline",
            },
            "*"
          );
        }
      });

    document
      .getElementById("widget-intro")
      .addEventListener("mouseover", () => {
        if (this.currentStep !== "widget-intro") {
          this.currentStep = "widget-intro";
          wn.postMessage(
            {
              type: "change-step",
              value: "widget-intro",
            },
            "*"
          );
        }
      });

    document.getElementById("widget-chat").addEventListener("mouseover", () => {
      if (this.currentStep !== "widget-chat") {
        this.currentStep = "widget-chat";
        wn.postMessage(
          {
            type: "change-step",
            value: "widget-chat",
          },
          "*"
        );
      }
    });
  },
  methods: {},
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    widgetUrl() {
      return env.WIDGET_IFRAME_URL;
    },
  },
  watch: {
    widgetParameters: {
      handler(newVal, oldVal) {
        let wn = document.getElementById("widger-iframe-preview").contentWindow;
        wn.postMessage(this.widgetParameters, "*");
        if (this.widgetParameters.hideFaqs && this.widgetParameters.hideForms) {
          wn.location.reload();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.chat-preview {
  padding: 25px;
  position: fixed;
  right: 50px;
  height: 70%;
  top: 60%;
  border-radius: 10px;
  background: #e3e3e3;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  width: 450px;
}
.chat-preview .card-header {
  padding: 0 30px;
  position: relative;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  background: #007fe8;
}
.chat-preview .logo {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin: 7px 0;
}
.chat-preview h5 {
  font-size: 25px;
  margin-bottom: 5px;
}
.chat-preview h6 {
  font-size: 17px;
}
.widget-chat-close {
  font-size: 25px;
  color: #f3f3f3;
}
.openBubbleImage {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  padding: 0;
  box-shadow: 0px 6px 8px 2px rgba(0, 0, 0, 0.14);
}
.openBubbleImage img {
  height: 32px;
  filter: brightness(0) invert(1);
}
.chat-body-wrapper {
  position: relative;
  height: 550px;
  background-size: cover;
}
.chat-preview .card-body {
  padding: 0;
}

.chat-preview .chat-body {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
}
.chat-preview .chat-body p {
  font-size: 16px;
  width: 80%;
  margin-bottom: 15px;
  padding: 14px;
}
.chat-preview .bot-side {
  float: left;
}
.chat-preview .user-side {
  float: right;
}
.chat-preview .chat-input {
  background-color: white;
  min-height: 40px;
  -webkit-box-align: stretch;
  align-items: stretch;
  border-top: 1px solid rgb(230, 230, 230);
  padding: 2px 5px;
  direction: ltr;
}
.chat-preview .row {
  margin: 0;
  display: flex;
  align-items: center;
}
.chat-preview .row > div:nth-of-type(1) {
  -webkit-flex-grow: 1;
}
.chat-preview .row > div:nth-of-type(2) {
  -webkit-flex-grow: 32;
}
</style>

<style></style>
